<template>
  <section class="gridClass my-8">
    <h4 class="font-bold text-xl laptop:text-2xl text-center">
      تعرفه‌های برقراری تماس نواتل در مقایسه با تماس مخابراتی بر حسب تومان بر
      دقیقه
    </h4>
    <table class="text-center mt-10 w-full shadow bg-gray-200 p-10">
      <tbody class="[&>tr>td]:py-3 [&>tr>td]:border [&>tr>td]:text-sm">
        <tr>
          <td class="">
            <div class="mt-2 font-bold">نوع تماس</div>
          </td>
          <td>
            <div class="flex justify-center items-center text-sm laptop:text-xl font-bold text-blue-500 p-1">
              <NuxtImg
                sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                width="1000"
                height="1000"
                class="w-6 laptop:w-8"
                format="webp"
                quality="100"
                src="/img/logo.png"
                alt="navatel logo"
              />
                <span class="">نواتل</span>
            </div>
            <!-- <NuxtImg class="mx-auto" format="webp" quality="100" src="/img/logo-mobile.webp" alt="" /> -->
          </td>
          <td>
            <div class="flex justify-center items-center text-sm laptop:text-xl font-bold text-blue-700 p-1">
              <NuxtImg 
                sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                width="1000"
                height="1000"
                class="w-6 laptop:w-8"
                format="webp"
                quality="100"
                src="/img/mokhaberat_logo.webp"
                alt="mokhaberat logo"
              />
                <span class="">مخابرات</span>
            </div>
            <!-- <NuxtImg class="mx-auto" format="webp" quality="100" src="/img/mokhaberat.webp" alt="" /> -->
          </td>
        </tr>
        <tr>
          <td class="color1">تماس با شماره ثابت خارج استان</td>
          <td class="color2">30</td>
          <td class="color1">33</td>
        </tr>
        <tr>
          <td class="color1">تماس با شماره ثابت داخل استان</td>
          <td class="color2">4</td>
          <td class="color1">4.5</td>
        </tr>
        <tr>
          <td class="color1">تماس با همراه</td>
          <td class="color2">55</td>
          <td class="color1">62.5</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
